<template>
  <div class="add-phone-dlg modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">{{ $t("Phones.AddPhoneDlg.Title") }}</p>
      <button
          type="button"
          class="delete"
          @click="close()"/>
    </header>
    <section class="modal-card-body">
      <div class="form-group">
        <b-radio v-model="addPhoneMode" class="add-phone-mode" name="addPhoneMode" :key="+AddPhoneMode.Organic" :native-value="+AddPhoneMode.Organic">
          {{ $t("Phones.AddPhoneDlg.Mode.Organic") }}
        </b-radio>
        <b-radio v-model="addPhoneMode" class="add-phone-mode" name="addPhoneMode" :key="+AddPhoneMode.Campaign" :native-value="+AddPhoneMode.Campaign">
          {{ $t("Phones.AddPhoneDlg.Mode.Campaign") }}
        </b-radio>
      </div>
      <div class="form-group dropdown-w full-width-field" v-show="phonesPageData && !phonesPageData.ClientId">
        <label class="caption">{{ $t('Leads.ClientPlaceholder') }}</label>
        <b-tooltip position="is-bottom" multilined type="is-dark">
          <b-dropdown v-model="selectedClient" scrollable :max-height="300" aria-role="list" :disabled="!clients.length"
                @active-change="onDropdownActiveChange">
            <template #trigger>
              <b-button>
                <span class="dropdown-trigger-value">{{ selectedClient?.Title || $t("Leads.ClientPlaceholder") }}</span>
                <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
              </b-button>
            </template>
            <b-dropdown-item custom aria-role="listitem" class="filter-search">
              <b-input v-model="clientsSearch" class="search" :placeholder="$t('Search')" expanded />
            </b-dropdown-item>
            <b-dropdown-item v-for="client in clientsFiltered" :key="client.ID" :value="client" aria-role="listitem">
              <span>{{ client.Title }}</span>
            </b-dropdown-item>
          </b-dropdown>
          <template v-slot:content>
            <p>{{ $t("Phones.Tooltips.Filters.Client") }}</p>
          </template>
        </b-tooltip>
      </div>

      <div v-if="addPhoneMode === AddPhoneMode.Campaign && selectedClientId">
        <div class="form-group">
          <label class="caption">{{ $t('CampaignEdit.Type.Caption') }}</label>
          <div class="radiogroup">
            <b-radio v-model="selectedMetadataType" name="selectedMetadataType" v-for="channelMetadataType in channelMetadataTypesFiltered"
                :key="+channelMetadataType.ID" :native-value="+channelMetadataType.ID">
              {{ channelMetadataType.Title }}
            </b-radio>
          </div>
        </div>
        <div class="form-group" v-if="isMediaChannel()">
          <b-field :label="$t('CampaignEdit.CampaignTitle')">
            <b-input v-model="campaignTitle" :placeholder="$t('CampaignEdit.CampaignTitlePlaceholder')"></b-input>
          </b-field>
        </div>
        <div class="form-group dropdown-w full-width-field" v-if="!isMediaChannel()">
          <label class="caption">{{ $t('Leads.ChannelPlaceholder') }}</label>
          <b-tooltip position="is-bottom" multilined type="is-dark">
            <b-dropdown v-model="selectedChannel" scrollable :max-height="300" aria-role="list" :disabled="!channels.length"
                  @active-change="onDropdownActiveChange">
              <template #trigger>
                  <b-button>
                    <span class="dropdown-trigger-value">{{ selectedChannel?.Title || $t("Leads.ChannelPlaceholder") }}</span>
                    <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
                  </b-button>
              </template>
              <b-dropdown-item custom aria-role="listitem" class="filter-search">
                <b-input v-model="channelsSearch" class="search" :placeholder="$t('Search')" expanded />
              </b-dropdown-item>
              <b-dropdown-item v-for="channel in channelsFiltered" :key="channel.ID" :value="channel"
                    aria-role="listitem" class="dropdown-item-with-icon">
                <span class="icon-w" v-if="getChannelMetadataTypeIconName(channel.ChannelMetadataType)">
                  <img :src="require('@/assets/' + getChannelMetadataTypeIconName(channel.ChannelMetadataType) + '.png')" />
                </span>
                <span class="text">{{ channel.Title }}</span>
              </b-dropdown-item>
            </b-dropdown>
            <template v-slot:content>
              <p>{{ $t("Leads.Tooltips.Filters.Channel") }}</p>
            </template>
          </b-tooltip>
        </div>
      </div>

      <div v-if="addPhoneMode === AddPhoneMode.Organic">
        <div class="dropdown-w" v-if="selectedClientId">
          <label>{{ $t('CampaignEdit.ProjectTypeId') }}</label>
          <b-tooltip :position="labelTooltipPosition" type="is-dark" class="label-tooltip">
            <span>
              <icon-base width="16" height="16" view-box="0 0 16 16" icon-name="chart-pie"><icon-question-circle /></icon-base>
            </span>
            <template #content>
              <p>{{ $t("CampaignEdit.ProjectTypeTooltip") }}</p>
            </template>
          </b-tooltip>
          <b-dropdown v-model="selectedProjectType" scrollable aria-role="list" :expanded="true"
                @active-change="onDropdownActiveChange" @change="onSelectedProjectTypeChange($event)">
            <template #trigger>
              <b-button>
                <span class="dropdown-trigger-value">{{ selectedProjectTypeListItem ? selectedProjectTypeListItem.Text : $t("CampaignEdit.Assets.CampaignTypePlaceholder") }}</span>
                <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
              </b-button>
            </template>
            <b-dropdown-item v-for="projectType in campaignEditAssetsData.ProjectTypes" :key="+projectType.Value" :value="+projectType.Value"
                  aria-role="listitem" class="dropdown-item-with-icon">
              <span class="text">{{ projectType.Text }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="dropdown-w" v-if="showAssetsSelectList">
          <label>{{ $t('CampaignEdit.Asset') }}</label>
          <b-dropdown v-model="selectedAssetId" scrollable aria-role="list" :expanded="true"
                @active-change="onDropdownActiveChange" @change="onSelectedAssetChange($event)">
            <template #trigger>
              <b-button>
                <span class="dropdown-trigger-value">{{ selectedClientAsset ? selectedClientAsset.title : $t("CampaignEdit.AssetPlaceholder") }}</span>
                <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
              </b-button>
            </template>
            <b-dropdown-item custom aria-role="listitem" class="filter-search">
              <b-input v-model="clientAssetsSearch" class="search" :placeholder="$t('Search')" expanded />
            </b-dropdown-item>
            <b-dropdown-item v-for="clientAsset in clientAssetsFiltered" :key="clientAsset.id" :value="clientAsset.id"
                  aria-role="listitem" class="dropdown-item-with-icon">
              <span class="text">{{ clientAsset.title }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="dropdown-w" v-if="showPropertiesSelectList">
          <label>{{ $t('CampaignEdit.Properties') }}</label>
          <b-dropdown v-model="selectedPropertyId" scrollable aria-role="list" :expanded="true"
                @active-change="onDropdownActiveChange" @change="onSelectedAssetChange($event)">
            <template #trigger>
              <b-button>
                <span class="dropdown-trigger-value">
                  {{ selectedClientProperty ? (selectedClientProperty.Url || selectedClientProperty.Title) : $t("CampaignEdit.PropertyPlaceholder") }}
                </span>
                <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
              </b-button>
            </template>
            <b-dropdown-item custom aria-role="listitem" class="filter-search">
              <b-input v-model="clientPropertiesSearch" class="search" :placeholder="$t('Search')" expanded />
            </b-dropdown-item>
            <b-dropdown-item v-for="clientProperty in clientPropertiesFiltered" :key="clientProperty.ID" :value="clientProperty.ID"
                  aria-role="listitem" class="dropdown-item-with-icon">
              <span class="text">{{ clientProperty.Url ? `${clientProperty.Title} - ${clientProperty.Url}` : clientProperty.Title }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </section>
    <footer class="modal-card-foot">
      <b-button
        :label="$t('Ok')"
        type="is-primary"
        :disabled="
          (addPhoneMode === AddPhoneMode.Organic &&
            (selectedProjectType === ProjectType.None || (!selectedAssetId && !selectedPropertyId))) ||
          (addPhoneMode === AddPhoneMode.Campaign && !selectedClientId)
        "
        @click="save()"
      />
      <b-button :label="$t('Cancel')" @click="close()" />
    </footer>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { campaignEditRoute } from "@/router";
import { ClientProject } from "@/models/ClientProject";
import { ChannelMultiselectItem, MultiselectItem, SelectListItem } from "@/models/MultiselectItem";
import { Result } from "@/models/Result";
import { ClientAsset } from "@/models/assets/ClientAsset";
import { ProjectProperty } from "@/models/assets/ProjectProperty";
import { ProjectType } from "@/models/assets/ProjectType";
import { SitePage } from "@/models/assets/SitePage";
import { CampaignEditViewModel } from "@/models/campaigns/Campaign";
import { CampaignEditAssetsData } from "@/models/campaigns/CampaignAsset";
import { AvailableChannelMetadataTypesMode, ChannelMetadataType, ChannelMetadataTypesForMediaCampaigns } from "@/models/campaigns/ChannelMetadataType";
import { PhonesPageData } from "@/models/phones/PhonesPageData";
import CampaignService from "@/services/CampaignService";
import ConfigService from "@/services/ConfigService";
import HelperService from "@/services/HelperService";
import { CommonMultiselectPayload } from "@/services/api/ApiService";
import CampaignsApiService, { GetCampaignEditViewModelPayload } from "@/services/api/CampaignsApiService";
import IconBase from "../IconBase.vue";
import IconCaretDown from "../icons/IconCaretDown.vue";
import IconQuestionCircle from "../icons/IconQuestionCircle.vue";

const namespace = "phonesModule";

@Component({
  components: {
    IconBase,
    IconCaretDown,
    IconQuestionCircle,
  },
})
export default class AddPhoneDlg extends Vue {

  //#region Vuex getters and actions

  @Getter("assets", { namespace: "leadsModule" }) assets!: ClientProject[];
  @Getter("channels", { namespace }) channels!: ChannelMultiselectItem[];
  @Getter("clients", { namespace }) clients!: MultiselectItem[];
  @Getter("phonesPageData", { namespace }) phonesPageData!: PhonesPageData;
  @Action("getAssets", { namespace: "leadsModule" }) getAssets!: (payload: CommonMultiselectPayload) => Promise<ClientProject[]>;
  @Action("getCampaignEditViewModel", { namespace: "campaignsModule" }) getCampaignEditViewModel!: (payload: GetCampaignEditViewModelPayload) => Promise<CampaignEditViewModel>;
  @Action("getChannels", { namespace }) getChannels!: (payload: CommonMultiselectPayload) => Promise<ChannelMultiselectItem[]>;

  //#endregion Vuex getters and actions


  //#region Properties

  addPhoneMode = AddPhoneMode.Organic;
  campaignTitle = "";
  channelsSearch = "";
  clientAssetsSearch = "";
  clientPropertiesSearch = "";
  clientsSearch = "";
  selectedAssetId = 0;
  selectedMetadataType = ChannelMetadataType.None;
  selectedProjectType = ProjectType.None;
  selectedPropertyId = 0;
  campaignEditAssetsData?: CampaignEditAssetsData = {
    IsAddAssetEnabled: false,
    ProjectTypes: []
  };
  selectedChannel: ChannelMultiselectItem | null = null;
  selectedClient: MultiselectItem | null = null;
  clientAssets: ClientAsset[] = [];
  clientProperties: ProjectProperty[] = [];
  sitePages: SitePage[] = [];

  AddPhoneMode = AddPhoneMode;
  ProjectType = ProjectType;

  //#endregion Properties


  //#region Watchers

  @Watch("addPhoneMode", { immediate: true })
  onAddPhoneModeChange(newAddPhoneMode: AddPhoneMode, oldAddPhoneMode: AddPhoneMode): void {
    if (newAddPhoneMode === undefined) {
      return;
    }
    if (!this.campaignEditAssetsData || this.campaignEditAssetsData.ProjectTypes.length === 0) {
      CampaignsApiService.getCampaignEditAssetsData(0).then((data: CampaignEditAssetsData) => {
        this.campaignEditAssetsData = data;
      });
    }
    if (newAddPhoneMode === AddPhoneMode.Campaign) {
      this.selectedMetadataType = ChannelMetadataType.Phone;
    }
  }

  @Watch("selectedMetadataType", { immediate: true })
  onSelectedMetadataTypeChange(newSelectedMetadataType: ChannelMetadataType, oldSelectedMetadataType: ChannelMetadataType): void {
    if (newSelectedMetadataType === undefined) {
      return;
    }
    if (!this.isMediaChannel(newSelectedMetadataType)) {
      this.getChannels(this.commonPayload);
    }
  }

  //#endregion Watchers


  //#region Getters

  get channelMetadataTypesFiltered(): MultiselectItem[] {
    let result: MultiselectItem[] = [];
    result.push(...CampaignService.getChannelMetadataTypes(AvailableChannelMetadataTypesMode.Campaigns));
    result.push(...CampaignService.getChannelMetadataTypes(AvailableChannelMetadataTypesMode.MediaCampaigns));
    return result;
  }

  get channelsFiltered(): ChannelMultiselectItem[] {
    return this.channels.filter((i: ChannelMultiselectItem) => i.Title.toLowerCase().indexOf(this.channelsSearch.toLowerCase()) >= 0);
  }

  get clientAssetsFiltered(): ClientAsset[] {
    return this.clientAssets.filter((i: ClientAsset) => i.title.toLowerCase().indexOf(this.clientAssetsSearch.toLowerCase()) >= 0);
  }

  get clientPropertiesFiltered(): ProjectProperty[] {
    return this.clientProperties.filter((i: ProjectProperty) => i.Title.toLowerCase().indexOf(this.clientPropertiesSearch.toLowerCase()) >= 0);
  }

  get clientsFiltered(): MultiselectItem[] {
    return this.clients.filter((i: MultiselectItem) => i.Title.toLowerCase().indexOf(this.clientsSearch.toLowerCase()) >= 0)
      .sort(HelperService.sortMultiselectItemsByIds(this.selectedClient ? [+this.selectedClient.ID] : []));
  }

  get commonPayload(): CommonMultiselectPayload {
    let clientIds: number[] = [];
    if (this.selectedClientId) {
      clientIds = [this.selectedClientId];
    }
    return {
      clientIds,
      showNotActiveCamp: false,
      metadataIds: [this.selectedMetadataType],
      statusIds: [],
      channelIds: [],
    };
  }

  get labelTooltipPosition(): string {
    return HelperService.isRtl() ? "is-left" : "is-right";
  }

  get selectedClientAsset(): ClientAsset | undefined {
    return this.clientAssets.find((i: ClientAsset) => i.id === +this.selectedAssetId);
  }

  get selectedClientId(): number | undefined {
    if (this.phonesPageData?.ClientId) {
      return this.phonesPageData.ClientId;
    } else if (this.selectedClient) {
      return +this.selectedClient.ID;
    }
    return undefined;
  }

  get selectedClientProperty(): ProjectProperty | undefined {
    return this.clientProperties.find((i: ProjectProperty) => i.ID === +this.selectedPropertyId);
  }

  get selectedProjectTypeListItem(): SelectListItem | undefined {
    return this.campaignEditAssetsData?.ProjectTypes.find((i: SelectListItem) => +i.Value === +this.selectedProjectType);
  }

  get showAssetsSelectList(): boolean {
    return [ProjectType.Custom, ProjectType.Facebook, ProjectType.Landing, ProjectType.Site].indexOf(this.selectedProjectType) >= 0;
  }

  get showPropertiesSelectList(): boolean {
    return [ProjectType.CustomLandingPage, ProjectType.CustomSite, ProjectType.ExternalAPI].indexOf(this.selectedProjectType) >= 0;
  }

  //#endregion Getters
  

  //#region Handlers

  close() {
    this.$emit("close");
  }

  onDropdownActiveChange(show: boolean) {
    HelperService.onDropdownActiveChange(show);
  }

  onSelectedAssetChange(assetId: number): void {
    
  }

  onSelectedProjectTypeChange(projectType: ProjectType): void {
    if (this.selectedClientId === undefined) {
      return;
    }
    if ([ProjectType.Custom, ProjectType.Facebook, ProjectType.Landing, ProjectType.Site].indexOf(projectType) >= 0) {
      const loader = this.$loading.show();
      CampaignsApiService.getClientAssets(this.selectedClientId, projectType, 0, 0)
      .then((clientAssets: ClientAsset[]) => {
        this.clientAssets = clientAssets;
        loader.hide();
      });
    } else if ([ProjectType.CustomLandingPage, ProjectType.CustomSite, ProjectType.ExternalAPI].indexOf(projectType) >= 0) {
      const loader = this.$loading.show({
        container: this.$refs.assetsTableContainer
      });
      CampaignsApiService.getClientAutoCompleteProperties(this.selectedClientId, projectType, 0, 0)
      .then((clientProperties: ProjectProperty[]) => {
        this.clientProperties = clientProperties;
        loader.hide();
      });
    }
  }

  save() {
    if (this.addPhoneMode === AddPhoneMode.Campaign) {
      if (this.isMediaChannel()) {
        let loader = this.$loading.show();
        this.getCampaignEditViewModel({
          createPhone: true,
          id: 0
        }).then((campaignEditViewModel: CampaignEditViewModel) => {
          campaignEditViewModel.Campaign.Active = true;
          campaignEditViewModel.Campaign.IsMediaChannel = this.isMediaChannel();
          campaignEditViewModel.Campaign.ChannelMetadataType = this.selectedMetadataType;
          campaignEditViewModel.Campaign.ChannelMetadataTypeID = +this.selectedMetadataType;
          campaignEditViewModel.Campaign.ClientId = this.selectedClientId || 0;
          campaignEditViewModel.Campaign.Title = this.campaignTitle;
          CampaignsApiService.saveCampaignGeneralInfo(campaignEditViewModel.Campaign).then((result: Result) => {
            if (result.Success) {
              campaignEditViewModel.Campaign.ID = result.Data as number;
              this.$router.push(`${campaignEditRoute}?ID=${campaignEditViewModel.Campaign.ID}#phones-channel`);
              this.close();
            } else {
              HelperService.showError(result.Message);
            }
          }).finally(() => {
            loader.hide();
          });
        });
      } else {
        if (this.selectedChannel) {
          this.$router.push(`${campaignEditRoute}?ID=${this.selectedChannel.ID}#phones-channel`);
          this.close();
        }
      }
    } else if (this.addPhoneMode === AddPhoneMode.Organic) {
      this.$loading.show();
      let assetId = 0;
      if (this.selectedAssetId) {
        assetId = this.selectedAssetId;
      } else if (this.selectedPropertyId) {
        assetId = this.selectedPropertyId;
      }
      location.href = `${this.getAssetEditUrl(this.selectedProjectType)}?ID=${assetId}#phones-channel`;
    }
  }

  //#endregion Handlers


  //#region Private methods

  private getAssetEditUrl(projectType: ProjectType): string {
    switch (projectType) {
      case ProjectType.Banner:
        return ConfigService.editBannerUrl;
      case ProjectType.Custom:
      case ProjectType.Landing:
        return ConfigService.editLandPageUrl;
      case ProjectType.CustomLandingPage:
      case ProjectType.CustomSite:
      case ProjectType.ExternalAPI:
        return ConfigService.editAssetUrl;
      case ProjectType.Facebook:
        return ConfigService.editExternalServiceUrl;
      case ProjectType.Site:
        return ConfigService.editSiteUrl;
      default:
        return "";
    }
  }

  private getChannelMetadataTypeIconName(type: string): string {
    return CampaignService.getChannelMetadataTypeIconName(+type);
  }

  private isMediaChannel(metadataType?: ChannelMetadataType): boolean {
    if (metadataType === undefined) {
      return ChannelMetadataTypesForMediaCampaigns.includes(this.selectedMetadataType);
    } else {
      return ChannelMetadataTypesForMediaCampaigns.includes(metadataType);
    }
  }

  //#endregion Private methods
}

enum AddPhoneMode {
  Organic,
  Campaign
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";

.add-phone-dlg.modal-card {
  width: auto;

  @media (min-width: 800px) {
    width: 800px;
  }

  .modal-card-body {
    min-height: 400px;

    .b-radio.radio:not(.button) {
      display: flex;
      margin-bottom: .5rem;
      margin-right: 2rem;
    }

    .form-group {
      margin-bottom: 1rem;

      label.caption {
        display: block;
        font-weight: 600;
        margin-bottom: .5rem;
      }

      .radiogroup {
        align-items: center;
        display: flex;
        flex-wrap: wrap;

        .b-radio.radio:not(.button) {
          margin-left: 0;
          margin-right: 0;
          width: 36%;

          @media (max-width: $bp_sm) {
            width: 50%;
          }

          @media (max-width: $bp_xs) {
            width: 100%;
          }
        }
      }
    }

    .full-width-field {
      .b-tooltip {
        width: 100%;

        .dropdown {
          width: 100%;

          .button {
            width: 100%;
          }

          .dropdown-item-with-icon {
            display: flex;

            .icon-w {
              display: flex;
              margin-inline-end: 0.5rem;
              min-width: 22px;

              img {
                max-height: 22px;
                min-width: 22px;
                width: 22px;
              }
            }
          }
        }
      }
    }

    .label-tooltip {
      margin-inline-start: 0.3rem;
    }
  }
}

html[dir="rtl"] {
  .add-phone-dlg.modal-card {
    .modal-card-body {
      .b-radio.radio:not(.button) {
        margin-left: 2rem;
        margin-right: 0;
      }
    }
  }
}
</style>
